import React, { useState } from 'react'

import { usePet } from '../../modules'

import Modal from "../reusable/modal"

const Ambulance = ({ toggle, visible, patient, onPerform }) => {
    const [price, setPrice] = useState()
    const [bill, setBill] = useState()

    usePet('saleItems', { string: 'Ambulance' }, { notify: true, callback: ({ data }) => {
        if (data?.items?.length > 0)
            setBill(data.items[0])
    } })

    const onComplete = (_, notif, ops) => {
        notif('Please record payment for the ambulance', ops('success'))
        onPerform()
        setTimeout(toggle, 100)
    }

    const [{ loading: loading }, billPatient] = usePet('billPatient', {
        patient: patient?._id,
        items: [{
            item: bill?._id,
            quantity: 1,
            price
        }],
        station: 'Cashier',
        standalone: true,
        inPatient: true
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Recording ambulance bill...' } })

    return (
        <Modal
            w={ 400 }
            title="Record Ambulance Bill"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Bill Total
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-qty"
                        type="number"
                        onChange={ e => setPrice(e.target.value)}
                        placeholder="Ksh. 40,000" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ billPatient } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Record Ambulance Bill</button>
            </div>
        </Modal>
    )
}

export default Ambulance